module.exports = __webpack_public_path__ + "media/images/badge-youtube-exporter-3cc5eb43ebe064eefb2abbadb0adcf2f.gif";